import type { getResult, StageStatus } from '../model/breakupQuiz'
import q from './BreakUpQuiz.module.css'

const labels: Record<StageStatus, string> = {
  done: 'Пройдена', current: 'Вы здесь', skipped: 'Пропущена', partial: 'Частично',
  partner: 'Прошёл партнёр', ahead: 'Впереди', none: '—',
}
export default function BreakUpQuizResult({ result }: { result: ReturnType<typeof getResult> }) {
  return <>
    <p className={q.eyebrow}>{result.currentStage ? `Сейчас вы здесь · этап ${result.currentStage}` : 'Ваш результат'}</p>
    <h1>{result.currentStageName}</h1>
    <p className={q.description}>{result.description}</p>
    {result.asymmetry && <div className={q.insight}>
      <h2>Вы проходите этот процесс не одновременно</h2>
      <p>{result.partnerText}</p>
      <p className={q.disclaimer}>Это предположение по вашим ответам, а не оценка состояния партнёра.</p>
    </div>}
    {result.insights.map((text) => <p className={q.insight} key={text}>{text}</p>)}
    <details className={q.path}>
      <summary>Посмотреть этапы по вашим ответам</summary>
      <ol>{result.stages.map((stage) => <li key={stage.id} className={stage.status === 'current' ? q.current : ''} aria-current={stage.status === 'current' ? 'step' : undefined}>
        <span>{stage.name}</span><small>{labels[stage.status]}</small>
      </li>)}</ol>
    </details>
    {result.unfinishedProcesses.length > 0 && <div className={q.insight}>
      <h2>Темы, к которым можно вернуться</h2>
      <ul>{result.unfinishedProcesses.map((stage) => <li key={stage.id}>{stage.name} — {labels[stage.status].toLowerCase()}</li>)}</ul>
    </div>}
    <p className={q.disclaimer}>Это ориентир, а не оценка: стадии можно пропускать и проходить в своём порядке. Если не совпадает, стадию можно сменить на экране «Путь».</p>
  </>
}
